
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_gwq0h_1ov8h_13",
  "expand-button": "awsui_expand-button_gwq0h_1ov8h_48",
  "icon": "awsui_icon_gwq0h_1ov8h_52",
  "expanded": "awsui_expanded_gwq0h_1ov8h_67",
  "icon-position": "awsui_icon-position_gwq0h_1ov8h_77",
  "icon-container": "awsui_icon-container_gwq0h_1ov8h_81",
  "icon-container-container": "awsui_icon-container-container_gwq0h_1ov8h_85",
  "wrapper": "awsui_wrapper_gwq0h_1ov8h_89",
  "wrapper-default": "awsui_wrapper-default_gwq0h_1ov8h_97",
  "wrapper-inline": "awsui_wrapper-inline_gwq0h_1ov8h_97",
  "wrapper-footer": "awsui_wrapper-footer_gwq0h_1ov8h_97",
  "wrapper-navigation": "awsui_wrapper-navigation_gwq0h_1ov8h_101",
  "wrapper-container": "awsui_wrapper-container_gwq0h_1ov8h_104",
  "wrapper-compact": "awsui_wrapper-compact_gwq0h_1ov8h_108",
  "header-deprecated": "awsui_header-deprecated_gwq0h_1ov8h_121",
  "wrapper-expanded": "awsui_wrapper-expanded_gwq0h_1ov8h_140",
  "wrapper-not-expanded-without-actions": "awsui_wrapper-not-expanded-without-actions_gwq0h_1ov8h_185",
  "header": "awsui_header_gwq0h_1ov8h_121",
  "header-wrapper": "awsui_header-wrapper_gwq0h_1ov8h_202",
  "header-actions-wrapper": "awsui_header-actions-wrapper_gwq0h_1ov8h_214",
  "header-button": "awsui_header-button_gwq0h_1ov8h_222",
  "header-container-button": "awsui_header-container-button_gwq0h_1ov8h_222",
  "header-container": "awsui_header-container_gwq0h_1ov8h_222",
  "header-navigation": "awsui_header-navigation_gwq0h_1ov8h_257",
  "icon-container-end": "awsui_icon-container-end_gwq0h_1ov8h_270",
  "header-text": "awsui_header-text_gwq0h_1ov8h_302",
  "content": "awsui_content_gwq0h_1ov8h_312",
  "content-expanded": "awsui_content-expanded_gwq0h_1ov8h_315",
  "content-compact": "awsui_content-compact_gwq0h_1ov8h_318",
  "content-inner": "awsui_content-inner_gwq0h_1ov8h_322",
  "content-inner-expanded": "awsui_content-inner-expanded_gwq0h_1ov8h_326",
  "content-inner-settled": "awsui_content-inner-settled_gwq0h_1ov8h_330",
  "content-inner-body-default": "awsui_content-inner-body-default_gwq0h_1ov8h_334",
  "content-inner-body-inline": "awsui_content-inner-body-inline_gwq0h_1ov8h_334",
  "content-inner-body-footer": "awsui_content-inner-body-footer_gwq0h_1ov8h_337",
  "content-inner-body-container": "awsui_content-inner-body-container_gwq0h_1ov8h_340",
  "disable-header-paddings": "awsui_disable-header-paddings_gwq0h_1ov8h_345",
  "disable-content-paddings": "awsui_disable-content-paddings_gwq0h_1ov8h_350",
  "focusable": "awsui_focusable_gwq0h_1ov8h_355",
  "click-target": "awsui_click-target_gwq0h_1ov8h_370",
  "header-icon-end": "awsui_header-icon-end_gwq0h_1ov8h_377",
  "header-button-icon-end": "awsui_header-button-icon-end_gwq0h_1ov8h_394",
  "header-content": "awsui_header-content_gwq0h_1ov8h_448",
  "header-navigation-content": "awsui_header-navigation-content_gwq0h_1ov8h_454"
};
  